import React from "react";
import Title from "../home/Title";
import BlogCard from "./BlogCard";
import { publications } from "../../data/publications";

const Publications = () => {
  return (
    <div className="w-full min-w-0">
      <Title title="Latest" subTitle="Publications" />
      {/* Below "lgl": horizontal swipe strip instead of two stacked cards.
          At "lgl" and up: the original two-column grid. */}
      <p className="lgl:hidden text-xs text-faintColor px-6 -mt-1 mb-2">
        Swipe to explore →
      </p>
      <div className="w-full min-w-0 flex gap-4 overflow-x-auto snap-x snap-mandatory pb-3 scrollbar-thin scrollbar-thumb-scrollThumb lgl:grid lgl:grid-cols-2 lgl:gap-6 lgl:overflow-visible lgl:pb-0 lgl:px-6 xl:gap-8">
        {publications.map(({ href, ...publication }) => (
          <a
            key={publication.subTitle}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex shrink-0 w-72 sm:w-80 lgl:w-auto lgl:shrink"
          >
            <BlogCard {...publication} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default Publications;
